import Vue from 'vue'
import moment from 'moment'

const appUtils = {}

moment.locale(process.env.APP_LOCALE)

appUtils.install = function (Vue) {
    Vue.prototype.$utils = {
        keyForLog (date, course, type, index) {
            return [ ('00' + date).slice(-2), course, type, index ].join('_')
        },
        formatDDD (month, date) {
            return this.getDate(month, date).format('ddd')
        },
        formatYYYYMMDD (month, date) {
            return this.getDate(month, date).format('YYYYMMDD')
        },
        formatYYYYMMDDDDD (month, date) {
            return this.getDate(month, date).format('YYYY/MM/DD(ddd)')
        },
        getDate (month, date) {
            return moment(month + '01').startOf('month').add(date - 1, 'days')
        },
        isToday (month, date) {
            return moment().format('YYYY/MM/DD') === this.getDate(month, date).format('YYYY/MM/DD')
        },
        getVersesFromCsv(items_csv) {
            if (!items_csv) {
                return []
            }
            let items = items_csv.split(',')
            return items
            return items.map((v, i) => {
                return v + '章'
            }).join(' ')
        },
        getUrlsFromCsv (items_csv) {
            if (!items_csv) {
                return []
            }
            let items = items_csv.split(',')
            return items
        },
        getVerseUrl (bible_code, book_code, verse) {
            return
                'https://my.bible.com/ja/bible/'
                + bible_code
                + '/'
                + book_code
                + '.'
                + verse
        },
        serializeformData(data, bracketsForArray) {
            let obj = {};
            for (let [key, value] of data) {
                if (obj[key] !== undefined) {
                    if (!Array.isArray(obj[key])) {
                        obj[key] = [obj[key]];
                    }
                    obj[key].push(value);
                } else {
                    obj[key] = value;
                }
            }
            if (bracketsForArray) {
                for (let key in obj) {
                    if (key.endsWith('[]')) {
                        obj[key.slice(0, -2)] = obj[key]
                        delete obj[key]
                    }
                }
            }
            return obj;
        },
    }
}

Vue.use(appUtils)

